import { Component } from '@angular/core';

@Component({
  selector: 'app-zh-tos-contents',
  templateUrl: './zh-tos-contents.component.html',
})
export class ChineseTOSContentsComponent {}
